import classNames from 'classnames/bind';
import React from 'react';
import Button, { ButtonMode } from '../Button';
import Icon, { ICONS } from '../Icon';
import style from './DataLoadError.module.scss';

const cx = classNames.bind(style);

interface DataLoadErrorProps {
  onRetryClick: () => void;
  disabled?: boolean;
}

const DataLoadError = ({ onRetryClick, disabled }: DataLoadErrorProps): React.ReactElement => {
  return (
    <div className={cx('body', { disabled })}>
      <div className={cx('error-container')} data-testid="data-load-error-container">
        <Icon name={ICONS.Alert} />
        <span>Error loading data</span>
        <Button className={cx('action')} onClick={onRetryClick} mode={ButtonMode.SECONDARY} ariaLabel="Refresh">
          <Icon name={ICONS.Refresh} />
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default DataLoadError;
